import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Spinner, Modal, RenderArrows } from '../../../../../components'
import Template from './Template'
import { Icon, message, Radio, Tooltip } from 'antd'
import { ModalInner, Footer, Save } from './styled'
import {
  HeadWrap,
  ZoomBtn,
  Btn,
  LandscapePageContent,
  LandscapePageWrapper,
  ZoomBtnGroup
} from '../../styled'
import './styles.scss'
import api from '../../../../../services/api'
import { useTranslation } from 'react-i18next'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import CustomPagination from '../../../../../components/CustomPagination/CustomPagination'

const ORIGINAL_WIDTH = 1023
const ORIGINAL_HEIGHT = 552

const ModalLessonLandscape = ({
  course = {},
  activeLessonId,
  lesson = {},
  toggleModal,
  modalVisible,
  userToken,
  enrollCourse,
  openNextLesson,
  lessonTitle = '',
  previewData__pages_landscape = [],
  previewCurrentPage = 1
}) => {
  const unityUnloadRef = useRef(null)
  const { t } = useTranslation('coursepage')
  const fullscreenRef = useRef(null)
  const modalInnerRef = useRef(null)
  const pageContentRef = useRef(null)
  const transformComponentRef = useRef(null)

  const isPreviewMode = previewData__pages_landscape.length > 0

  const lessons = course.courses_lessons || []
  const enrollment = course.enrollment || {}
  const lessonItem = lessons.find(i => i.id === activeLessonId)
  const uids = isPreviewMode
    ? previewData__pages_landscape.map(page => page.uid)
    : lessonItem && lessonItem.info && lessonItem.info.pages_uids
      ? lessonItem.info.pages_uids
      : []
  const completedUids =
    enrollment.progress && enrollment.progress[lessonItem.id]
      ? enrollment.progress[lessonItem.id]
      : []
  const initialIndex = uids.findIndex(uid => !completedUids.includes(uid))

  const [currentPage, setCurrentPage] = useState(
    isPreviewMode ? previewCurrentPage : initialIndex < 1 ? 1 : initialIndex
  )
  const [isMoveable, setIsMoveable] = useState(false)
  const [isGoToNextPageDisabled, setIsGoToNextPageDisabled] = useState(false)
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [scaleFactor, setScaleFactor] = useState(1)
  const [shouldResetTransform, setShouldResetTransform] = useState(false)

  console.log({
    isPreviewMode,
    previewCurrentPage,
    currentPage
  })

  const calculateScaleFactor = useCallback(() => {
    if (isFullscreen) {
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight
      const widthRatio = screenWidth / ORIGINAL_WIDTH
      const heightRatio = screenHeight / ORIGINAL_HEIGHT
      return Math.min(widthRatio, heightRatio)
    }
    return 1
  }, [isFullscreen])

  const doResize = useCallback(() => {
    const newScaleFactor = calculateScaleFactor()
    setScaleFactor(newScaleFactor)
  }, [calculateScaleFactor])

  useEffect(() => {
    doResize()
    window.addEventListener('resize', doResize)
    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', handleFullscreenChange)

    return () => {
      window.removeEventListener('resize', doResize)
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener(
        'webkitfullscreenchange',
        handleFullscreenChange
      )
      document.removeEventListener(
        'mozfullscreenchange',
        handleFullscreenChange
      )
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange)
      if (!isPreviewMode) {
        postCheckOutData('willUnMount landscape')
      }
    }
  }, [doResize, isPreviewMode])

  useEffect(() => {
    doResize()
    if (!isFullscreen) {
      setShouldResetTransform(true)
    }
  }, [isFullscreen])

  useEffect(() => {
    if (shouldResetTransform && transformComponentRef.current) {
      transformComponentRef.current.resetTransform()
      setScaleFactor(1)
      setShouldResetTransform(false)
    }
  }, [shouldResetTransform])

  const postCheckOutData = param => {
    if (isPreviewMode) return

    const data = { user_token: userToken }
    api.courses
      .checkOutCourse(course.id, data)
      .then(({ data }) => {
        console.log('response log checkout', data)
      })
      .catch(e => { })
  }

  const changePage = async page => {
    console.log('=== changePage START ===')
    console.log('Current page:', currentPage, 'New page:', page)
    console.log('unityUnloadRef:', unityUnloadRef)
    console.log('unityUnloadRef.current:', unityUnloadRef.current)

    if (isGoToNextPageDisabled) {
      message.warning(t('v3:warning_complete_quiz'))
      return
    }

    if (page > currentPage + 1) {
      return
    }

    // Trigger Unity unload before changing page
    if (unityUnloadRef.current) {
      console.log('Calling Unity unload...')
      try {
        await unityUnloadRef.current()
        console.log('Unity unload completed, waiting 200ms...')
        // Small delay to ensure cleanup
        await new Promise(resolve => setTimeout(resolve, 200))
      } catch (error) {
        console.error('Error during Unity unload:', error)
      }
    } else {
      console.log('unityUnloadRef.current is null/undefined')
    }

    console.log('Setting current page to:', page)
    setCurrentPage(page)

    if (
      !isPreviewMode &&
      lesson.item &&
      lesson.item.pages_landscape &&
      lesson.item.pages_landscape[page - 1]
    ) {
      const { uid } = lesson.item.pages_landscape[page - 1]
      console.log('enroll course data check', course.id, lesson.item.id, uid)
      enrollCourse(course.id, lesson.item.id, uid)
    }

    console.log('=== changePage END ===')
  }

  const handleOpenNextLesson = id => {
    if (!isPreviewMode) {
      postCheckOutData()
    }
    setCurrentPage(1)
    openNextLesson(id)
  }

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      if (fullscreenRef.current.requestFullscreen) {
        fullscreenRef.current.requestFullscreen()
      } else if (fullscreenRef.current.mozRequestFullScreen) {
        fullscreenRef.current.mozRequestFullScreen()
      } else if (fullscreenRef.current.webkitRequestFullscreen) {
        fullscreenRef.current.webkitRequestFullscreen()
      } else if (fullscreenRef.current.msRequestFullscreen) {
        fullscreenRef.current.msRequestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    }
  }

  const handleFullscreenChange = () => {
    setIsFullscreen(!!document.fullscreenElement)
  }

  const FooterElement = () => {
    if (!lessons || !Array.isArray(lessons) || lessons.length === 0) {
      return (
        <Footer id="course_view_footer" isFullscreen={isFullscreen}>
          <Footer.Wrapp>
            <div className="styled-pagination">
              <CustomPagination
                currentPage={currentPage}
                totalPages={
                  isPreviewMode ? previewData__pages_landscape.length : 0
                }
                onPageChange={changePage}
                loading={lesson.fetch}
              />
            </div>
          </Footer.Wrapp>
        </Footer>
      )
    }

    const currentLessonIndex = lessons.findIndex(i => i.id === activeLessonId)
    const isLastLesson =
      currentLessonIndex === -1
        ? false
        : currentLessonIndex === lessons.length - 1

    const totalPages = isPreviewMode
      ? previewData__pages_landscape.length
      : lesson.item && lesson.item.pages_landscape
        ? lesson.item.pages_landscape.length
        : 0

    const isLastPage = currentPage === totalPages

    let nextLessonTitle = ''
    if (
      !isLastLesson &&
      currentLessonIndex !== -1 &&
      lessons[currentLessonIndex + 1]
    ) {
      nextLessonTitle = lessons[currentLessonIndex + 1].title || ''
    }

    return (
      <Footer id="course_view_footer" isFullscreen={isFullscreen}>
        <Footer.Wrapp spaceBetween={isLastPage}>
          <div className="styled-pagination">
            <CustomPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={changePage}
              loading={lesson.fetch}
            />
          </div>
          {isLastPage && !isPreviewMode && currentLessonIndex !== -1 && (
            <>
              {isLastLesson ? (
                <Btn
                  type="primary"
                  className="rounded"
                  onClick={() => handleOpenNextLesson(lesson.item.id)}
                >
                  {t('buttons:close_lesson')}
                </Btn>
              ) : (
                nextLessonTitle && (
                  <NextLessonButton
                    onClick={() => handleOpenNextLesson(lesson.item.id)}
                    lessonTitle={nextLessonTitle}
                  />
                )
              )}
            </>
          )}
        </Footer.Wrapp>
      </Footer>
    )
  }

  const NextLessonButton = ({ onClick, lessonTitle = '' }) => {
    return (
      <div className="next-lesson-button" onClick={onClick}>
        <div className="next-lesson-button__title">
          <span>{t('buttons:next_lesson')}</span>
          <h3>{lessonTitle}</h3>
        </div>
        <Icon type="right" />
      </div>
    )
  }

  const RenderZoomButtons = ({ zoomIn, zoomOut, resetTransform }) => {
    return (
      <ZoomBtnGroup>
        <Radio.Group>
          <Tooltip title={t('v4:zoom_in')}>
            <Radio.Button value="zoom-in" onClick={() => zoomIn()}>
              <Icon type="zoom-in" />
            </Radio.Button>
          </Tooltip>
          <Tooltip title={t('v4:zoom_out')}>
            <Radio.Button value="zoom-out" onClick={() => zoomOut()}>
              <Icon type="zoom-out" />
            </Radio.Button>
          </Tooltip>
          <Tooltip title={t('v4:zoom_reset')}>
            <Radio.Button
              value="zoom-reset"
              onClick={() => {
                resetTransform()
                setScaleFactor(1)
              }}
            >
              <Icon type="reload" />
            </Radio.Button>
          </Tooltip>
        </Radio.Group>
        <ZoomBtn icon="fullscreen" onClick={toggleFullscreen}>
          {isFullscreen ? t('v4:exit_fullscreen') : t('v4:fullscreen')}
        </ZoomBtn>
      </ZoomBtnGroup>
    )
  }

  const getCurrentLessonTitle = (lessons, activeLessonId) => {
    if (!lessons || !Array.isArray(lessons) || lessons.length === 0) return ''

    const index = lessons.findIndex(i => i.id === activeLessonId)
    if (index === -1) return ''

    return lessons[index] && lessons[index].title ? lessons[index].title : ''
  }

  const currentLessonTitle = getCurrentLessonTitle(lessons, activeLessonId)
  const renderPageContent = () => {
    if (isPreviewMode) {
      if (
        !previewData__pages_landscape[currentPage - 1] ||
        !previewData__pages_landscape[currentPage - 1].data
      ) {
        return null
      }
      return previewData__pages_landscape[currentPage - 1].data.map(page => {
        if (!page.params || !page.params.content) {
          return null
        }
        return (
          <Template
            key={page.uid}
            node={page}
            ids={{
              courseId: course.id,
              lessonId: activeLessonId,
              pageId: previewData__pages_landscape[currentPage - 1].id
            }}
            onDragStart={() => setIsMoveable(true)}
            onDragStop={() => setIsMoveable(false)}
            toggleQuizRestriction={setIsGoToNextPageDisabled}
            isFullscreen={isFullscreen}
            scaleFactor={scaleFactor}
            unityUnloadRef={unityUnloadRef} // Add this
          />
        )
      })
    }

    if (
      !lesson.item ||
      !lesson.item.pages_landscape ||
      !lesson.item.pages_landscape[currentPage - 1] ||
      !lesson.item.pages_landscape[currentPage - 1].data
    ) {
      return null
    }

    return lesson.item.pages_landscape[currentPage - 1].data.map(page => {
      if (!page.params || !page.params.content) {
        return null
      }
      return (
        <Template
          key={page.uid}
          node={page}
          ids={{
            courseId: course.id,
            lessonId: activeLessonId,
            pageId: lesson.item.pages_landscape[currentPage - 1].id
          }}
          onDragStart={() => setIsMoveable(true)}
          onDragStop={() => setIsMoveable(false)}
          toggleQuizRestriction={setIsGoToNextPageDisabled}
          isFullscreen={isFullscreen}
          scaleFactor={scaleFactor}
          unityUnloadRef={unityUnloadRef} // Add this
        />
      )
    })
  }

  return (
    <Modal
      width="1085px"
      visible={modalVisible}
      style={{ height: '780px', position: 'relative' }}
      onCancel={() => toggleModal()}
      destroyOnClose
      footer={false}
      centered
    >
      <div ref={modalInnerRef} style={{ width: '100%', height: '100%' }}>
        <TransformWrapper
          ref={transformComponentRef}
          initialScale={scaleFactor}
          minScale={1}
          maxScale={7}
          limitToBounds={true}
          initialPositionX={0}
          initialPositionY={0}
          wheel={{ disabled: true }}
          disabled={isFullscreen || isMoveable}
          doubleClick={{
            mode: 'reset'
          }}
          panning={{ excluded: ['input', 'textarea'] }}
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <ModalInner>
              <section
                className="section"
                style={{
                  paddingBottom: 0,
                  paddingLeft: 0,
                  background: 'white'
                }}
              >
                <HeadWrap isFullscreen={isFullscreen}>
                  <div className="course-preview__head-title">
                    <Icon
                      className="course-preview__head-title__icon"
                      type="read"
                    />
                    <div className="course-preview__head-title__text">
                      <h2>
                        {isPreviewMode ? t('v5:lesson_preview') : course.title}
                      </h2>
                      <p>
                        <h3>
                          {isPreviewMode ? lessonTitle : currentLessonTitle}
                        </h3>
                      </p>
                    </div>
                  </div>
                  {!lesson.fetch && (
                    <RenderZoomButtons
                      zoomIn={zoomIn}
                      zoomOut={zoomOut}
                      resetTransform={resetTransform}
                    />
                  )}
                </HeadWrap>
              </section>
              <TransformComponent
                wrapperStyle={{
                  width: '100%'
                }}
                contentStyle={{ width: `100%` }}
              >
                <LandscapePageWrapper ref={fullscreenRef}>
                  {lesson.fetch ? (
                    <LandscapePageContent isFullscreen={isFullscreen} loading>
                      <Spinner size={10} top={35} />
                    </LandscapePageContent>
                  ) : (
                    <LandscapePageContent
                      isFullscreen={isFullscreen}
                      ref={pageContentRef}
                    >
                      {renderPageContent()}
                    </LandscapePageContent>
                  )}
                  {isFullscreen && <FooterElement />}
                </LandscapePageWrapper>
              </TransformComponent>
            </ModalInner>
          )}
        </TransformWrapper>
      </div>

      <FooterElement />
    </Modal>
  )
}

export default ModalLessonLandscape
